// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"0e992dd2","348":"e6340cf8","571":"3173974c","924":"4b62bc1a"}[chunkId] + ".chunk.js";
};